import { Controller } from "stimulus";
import Select2 from "select2";

// This is a universal ajax select2 to be used with or without modals
// Set it up like so - data: { controller: 'select2', target: 'select2.url', url: 'residents/select2', target_class: 'select2-ajax-residents' }
// Add an input html on the select element with the target class

export default class extends Controller {
  static targets = ['url']

  connect() {
    if ($(this.urlTarget).data('modal')) {
      this.loadModalSelectInput();
    } else {
      setTimeout(() => this.loadSelectInput(), 100) // select2 does not initialize without a small time delay
    }
  }

  disconnect() {
    if (this.onModalShown) {
      $('#envida-modal').off('shown.bs.modal', this.onModalShown)
      this.onModalShown = null
    }
  }

  loadSelectInput() {
    $(this.targetClass).select2(this.select2Data);
    const controller = this

    // re-initialize select2s when modal closes
    $('#envida-modal').on('hidden.bs.modal', () => {
      $(controller.urlTarget).find('.select2').remove()
      setTimeout(() => controller.loadSelectInput(), 10)
    })
    this.setDefaultSelected()
  }

  loadModalSelectInput() {
    const data = this.select2Data
    data.dropdownParent = $('#envida-modal')
    data.placeholder = "Search"
    this.setDefaultSelected()

    const modal = $('#envida-modal')
    // Validation errors replace the modal body while it is already open, so
    // shown.bs.modal does not fire again. Initialize immediately in that case.
    if (modal.hasClass('show')) {
      this.initModalSelect(data)
      return
    }

    this.onModalShown = () => this.initModalSelect(data)
    modal.one('shown.bs.modal', this.onModalShown)
  }

  initModalSelect(data) {
    if (!this.element.isConnected) return

    const $select = $(this.targetClass)
    if (!$select.length) return

    $select.select2(data)
  }

  setDefaultSelected() {
    const selectedId = $(this.targetClass).data('selectedId')
    if (selectedId) {
      const selectedText = $(this.targetClass).data('selectedText')
      const newOption = new Option(selectedText, selectedId, true, true)
      $(this.targetClass).append(newOption).trigger('change')
    }
  }

  get targetClass() {
    return `.${$(this.urlTarget).data('targetClass')}`
  }

  get select2Data() {
    const url = $(this.urlTarget).data('url')

    return {
      minimumInputLength: 0,
      ajax: {
        url: `/${url}.json`,
        cache: true,
        dataType: 'json',
        delay: 250,
        data: params => ({
          q: params.term,
          page: params.page
        }),
        processResults: (data, params) => {
          params.page = params.page || 1;
          return {
            results: data.items,
            pagination: {
              more: (params.page * 20) < data.total_count
            }
          }
        }
      }
    }
  }
}